export default "__VITE_ASSET__DnNi570t__"